/**
 * Product Nav Module
 * Carousel nawigacji produktowej ze strzałkami prev/next.
 *
 * Użycie:
 *   <section class="product-nav">
 *     <div class="product-nav__wrapper">
 *       <button class="product-nav__arrow product-nav__arrow--prev">...</button>
 *       <div class="product-nav__carousel">
 *         <div class="product-nav__items">...</div>
 *       </div>
 *       <button class="product-nav__arrow product-nav__arrow--next">...</button>
 *     </div>
 *   </section>
 */

(function () {
    'use strict';

    // ============================================
    // SELECTORS
    // ============================================
    var SELECTORS = {
        nav: '.product-nav:not(.product-nav--packshot-carousel)',
        items: '.product-nav__items',
        item: '.product-nav__item',
        prevBtn: '.product-nav__arrow--prev',
        nextBtn: '.product-nav__arrow--next'
    };

    var CLASSES = {
        disabled: 'is-disabled'
    };

    // ============================================
    // INITIALIZATION
    // ============================================
    function init() {
        var navs = document.querySelectorAll(SELECTORS.nav);
        if (!navs.length) return;

        navs.forEach(function (nav) {
            var items = nav.querySelector(SELECTORS.items);
            var prevBtn = nav.querySelector(SELECTORS.prevBtn);
            var nextBtn = nav.querySelector(SELECTORS.nextBtn);

            if (!items || !prevBtn || !nextBtn) return;

            // Oblicz szerokość scrollowania (thumb + gap)
            function getScrollAmount() {
                var item = items.querySelector(SELECTORS.item);
                if (!item) return 120;
                var style = window.getComputedStyle(items);
                var gap = parseFloat(style.gap) || 24;
                return item.offsetWidth + gap;
            }

            // Aktualizuj stan strzałek
            function updateArrows() {
                var scrollLeft = Math.round(items.scrollLeft);
                var maxScroll = items.scrollWidth - items.clientWidth;

                if (scrollLeft <= 0) {
                    prevBtn.classList.add(CLASSES.disabled);
                } else {
                    prevBtn.classList.remove(CLASSES.disabled);
                }

                if (scrollLeft >= maxScroll - 1) {
                    nextBtn.classList.add(CLASSES.disabled);
                } else {
                    nextBtn.classList.remove(CLASSES.disabled);
                }
            }

            // Event listeners
            prevBtn.addEventListener('click', function () {
                items.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
            });

            nextBtn.addEventListener('click', function () {
                items.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
            });

            items.addEventListener('scroll', updateArrows);
            window.addEventListener('resize', updateArrows);

            // Scroll do aktywnego elementu na starcie
            var activeItem = items.querySelector('.product-nav__item.is-active');
            if (activeItem) {
                var itemLeft = activeItem.offsetLeft;
                var containerWidth = items.clientWidth;
                var itemWidth = activeItem.offsetWidth;
                var scrollTo = itemLeft - (containerWidth / 2) + (itemWidth / 2);
                items.scrollLeft = Math.max(0, scrollTo);
            }

            // Ustaw stan strzałek na starcie
            updateArrows();
        });
    }

    // ============================================
    // RUN
    // ============================================
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
